import AlertInlineMessage from '@components/ui/AlertInlineMessage';
import Button from '@components/ui/Button';
import { useTranslation } from 'next-i18next';
import { MecProduct } from '@adapters/bigcommerce/types/product';
import { usePdp } from '@context/PdpContext';
import { useLocale } from '@hooks/useLocale';
import styles from './ProductNotInStockSection.module.scss';

interface ProductNotInStockSectionProps {
  breadcrumbs: MecProduct['breadcrumbs'];
}

const ProductNotInStockSection = ({
  breadcrumbs,
}: ProductNotInStockSectionProps) => {
  const { t } = useTranslation(['pdp']);
  const { productCode } = usePdp();
  const locale = useLocale();
  // This is temporary ER-3814 until more stock comes back for this product
  const IS_SERRATUS_PACK = productCode === '6020-287';

  const breadcrumbPath =
    breadcrumbs[breadcrumbs?.length - 1]?.path?.replace(/\/$/, '') || '';

  return (
    <div className={styles.stockMessage}>
      <AlertInlineMessage
        messageType={IS_SERRATUS_PACK ? 'INFORMATION' : 'ERROR'}
        classNames={styles.outOfStockAlert}
      >
        <span>
          {t(
            IS_SERRATUS_PACK ? 'product.will.return' : 'product.not.available'
          )}
        </span>
      </AlertInlineMessage>
      {breadcrumbs && breadcrumbs.length > 0 && (
        <Button
          href={`/${locale}${breadcrumbPath}`}
          label={
            <span>
              <span> {t('product.not.available.button')}</span>
              {` ${breadcrumbs[breadcrumbs?.length - 1]?.name.toLowerCase()}`}
            </span>
          }
          variant="primary"
          size="large"
          className={styles.outOfStockButton}
        />
      )}
    </div>
  );
};

export default ProductNotInStockSection;
